import { z } from 'zod/v4';

import { driverVehicleLinkSchema } from './driver-vehicle-link.schema';

export const vehicleDriverLinkSchema = z.object({
  vehicleId: z.string(),
  vehicleDriverLinks: z.array(driverVehicleLinkSchema),
});

export type VehicleDriverLink = z.infer<typeof vehicleDriverLinkSchema>;
